import type { Frontiers } from '@larki/shared/types/map2d.type';
import type { Get2dMapStateFromJobResBody } from '@larki/shared/type/service/map2d';

type Map2dBytes = Pick<Get2dMapStateFromJobResBody, 'bytes'>;

// Replay can fail with 422 (stale frontiers — e.g. history compaction or
// Loro shape upgrade). Fall back to the live map so the preview still
// renders, just without the activity-time snapshot.
export async function resolveMap2dBytes({
  map2dId,
  activityFrontiers,
  replay,
  getLive,
}: {
  map2dId: number;
  activityFrontiers: Frontiers | null;
  replay: (args: { id: number; frontiers: Frontiers }) => Promise<Map2dBytes>;
  getLive: (args: { id: number }) => Promise<Map2dBytes>;
}): Promise<Map2dBytes> {
  if (activityFrontiers) {
    try {
      return await replay({ id: map2dId, frontiers: activityFrontiers });
    } catch (error) {
      console.warn(
        'resolveMap2dBytes: replay failed, falling back to live map',
        { map2dId, error }
      );
    }
  }
  return await getLive({ id: map2dId });
}
